import { ArrowUp, Check, Clock, UserCheck, X } from 'lucide-react'
import { ReactNode } from 'react'

import {
  SUPPORT_STATUS_LABEL,
  SupportRequestStatusEnum,
} from '@/app/entities/SupportRequest'
import { Button } from '@/view/components/ui/button'

const ACTION_LABEL: Partial<Record<SupportRequestStatusEnum, string>> = {
  [SupportRequestStatusEnum.IN_PROGRESS]: 'Assumir chamado',
  [SupportRequestStatusEnum.ESCALATED_TECHNICAL]: 'Escalar ao técnico',
  [SupportRequestStatusEnum.AWAITING_SELLER]: 'Aguardando retorno do vendedor',
}

const ACTION_ICON: Partial<Record<SupportRequestStatusEnum, ReactNode>> = {
  [SupportRequestStatusEnum.IN_PROGRESS]: <UserCheck className="h-4 w-4" />,
  [SupportRequestStatusEnum.ESCALATED_TECHNICAL]: (
    <ArrowUp className="h-4 w-4" />
  ),
  [SupportRequestStatusEnum.AWAITING_SELLER]: <Clock className="h-4 w-4" />,
}

const ACTION_ORDER = [
  SupportRequestStatusEnum.IN_PROGRESS,
  SupportRequestStatusEnum.ESCALATED_TECHNICAL,
  SupportRequestStatusEnum.AWAITING_SELLER,
]

interface SupportRequestStatusBarProps {
  availableTransitions: SupportRequestStatusEnum[]
  disabled: boolean
  onSelect: (status: SupportRequestStatusEnum) => void
}

export const SupportRequestStatusBar = ({
  availableTransitions,
  disabled,
  onSelect,
}: SupportRequestStatusBarProps) => {
  const actions = ACTION_ORDER.filter((status) =>
    availableTransitions.includes(status),
  )
  const canCancel = availableTransitions.includes(
    SupportRequestStatusEnum.CANCELLED,
  )
  const canResolve = availableTransitions.includes(
    SupportRequestStatusEnum.RESOLVED,
  )

  if (!actions.length && !canCancel && !canResolve) return null

  return (
    <div className="mt-16 flex flex-wrap items-center justify-between gap-2 rounded-xl border border-gray01 bg-white p-3">
      <div className="flex flex-wrap items-center gap-2">
        {actions.map((status) => (
          <Button
            key={status}
            type="button"
            variant="outline"
            size="sm"
            disabled={disabled}
            onClick={() => onSelect(status)}
            className="gap-2"
          >
            {ACTION_ICON[status]}
            {ACTION_LABEL[status] ?? SUPPORT_STATUS_LABEL[status]}
          </Button>
        ))}
      </div>

      <div className="flex flex-wrap items-center gap-2">
        {canCancel && (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            disabled={disabled}
            onClick={() => onSelect(SupportRequestStatusEnum.CANCELLED)}
            className="gap-1 text-error hover:text-error"
          >
            <X className="h-4 w-4" />
            Cancelar
          </Button>
        )}

        {canResolve && (
          <Button
            type="button"
            size="sm"
            disabled={disabled}
            onClick={() => onSelect(SupportRequestStatusEnum.RESOLVED)}
            className="gap-2 bg-green-700 text-white hover:bg-green-800"
          >
            <Check className="h-4 w-4" />
            Marcar como resolvido
          </Button>
        )}
      </div>
    </div>
  )
}
